import React from "react";
import { useParams, Navigate } from "react-router-dom";

// /r/:code — short referral redirect. Forwards to /signup?ref=CODE.
export default function ReferralRedirect() {
  const { code } = useParams();
  const clean = (code || "").trim().toUpperCase();
  if (!clean) return <Navigate to="/signup" replace />;
  return <Navigate to={`/signup?ref=${encodeURIComponent(clean)}`} replace />;
}
